import { render, staticRenderFns } from "./goods.vue?vue&type=template&id=7f9b46e3&"
import script from "./goods.vue?vue&type=script&lang=js&"
export * from "./goods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a2\\Code_New\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f9b46e3')) {
      api.createRecord('7f9b46e3', component.options)
    } else {
      api.reload('7f9b46e3', component.options)
    }
    module.hot.accept("./goods.vue?vue&type=template&id=7f9b46e3&", function () {
      api.rerender('7f9b46e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/config/goods.vue"
export default component.exports